module.exports = __webpack_public_path__ + "static/img/9.ebc088d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/03/9.png
// module id = SsSj
// module chunks = 1